import * as ents from '@attain-apps/entities'
export namespace AtnDsNumberType {
  export function getSuffix(
    type: ents.core.common.value.types.Intrinsic.ForNumber,
  ): string {
    switch (type) {
      case ents.core.common.value.types.Intrinsic.Percent:
        return '%'
      default:
        return ''
    }
  }

  export function getPrefix(
    type: ents.core.common.value.types.Intrinsic.ForNumber,
  ): string {
    switch (type) {
      case ents.core.common.value.types.Intrinsic.Currency:
        return '$'
      default:
        return ''
    }
  }
}
